class Interview {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    var progressBar = new Swiper('.js-interview-progress-bar', {
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar" /* この行を追加 */
      },
    });
    var interviewSwiper = new Swiper('.js-interview-swiper', {
      slidesPerView: 1.4,
      spaceBetween: 10,
      autoplay: {
        delay: 3000
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction" /* この行を追加 */
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      thumbs: {
        swiper: progressBar
      },
      breakpoints: {
        851: {
          slidesPerView: 3,
          spaceBetween: 0,
          loopAdditionalSlides: 1
        }
      }
    });
    interviewSwiper.autoplay.stop(); //画面に現れるまでswiperを停止
    $(window).on('scroll', function () {
        let position = $('.js-interview-swiper').offset().top - $(window).innerHeight() + 100,
            scrollTop = $(window).scrollTop(); 
        if(scrollTop > position) {
          interviewSwiper.autoplay.start(); //画面に現れたらswiperを開始
        }else{
          interviewSwiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
        }
    });
  }
}